import React from 'react';

import {
  AutoriteFourriereDto,
  AutoriteFourriereViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { AutoriteFourriereFormValues } from '../type';
import { buildFormValues, buildRequestDto } from '../utils';

import ModalEditionAutoriteFourriere from './ModalEditionAutoriteFourriere';

interface ModalUpdateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
  autorite: AutoriteFourriereDto;
}

function ModalUpdate({
  close,
  visible,
  refreshDashboard,
  autorite,
}: ModalUpdateProps): React.ReactElement {
  const initials: AutoriteFourriereFormValues = buildFormValues(autorite);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: AutoriteFourriereFormValues) =>
      AdminFonctionnelControllerApi.updateAutoriteFourriereUsingPUT(
        autorite.idCorrelation,
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: AutoriteFourriereViolationDtoFormFieldEnum,
      values: AutoriteFourriereFormValues,
    ) =>
      AdminFonctionnelControllerApi.validateUpdateAutoriteFourriereFieldUsingPOST(
        field,
        autorite.idCorrelation,
        buildRequestDto(values),
      ),
    response => response.autoriteFourriereViolationsDto ?? [],
  );

  return (
    <ModalEditionAutoriteFourriere
      close={close}
      visible={visible}
      title="Mise à jour de l'autorité de fourrière"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
      additionalInputs={[
        {
          field: AutoriteFourriereViolationDtoFormFieldEnum.ID_ALIENATION,
          name: 'idAlienation',
          tooltipProps: {
            title:
              'Attention: toute modification de cet ID créé par la DNID aura des conséquences sur les flux de remises de véhicules à vendre.',
            trigger: ['focus'],
            placement: 'top',
          },
          label: 'Id Alienation',
        },
        {
          field:
            AutoriteFourriereViolationDtoFormFieldEnum.ID_ALIENATION_UTILISATEUR,
          name: 'idAlienationUtilisateur',
          label: 'Id Alienation utilisateur remettant',
        },
      ]}
    />
  );
}

export default ModalUpdate;
